import { version } from '../../../../package.json';

/**
 * Cổng sinh viên MỚI (Student Workspace, Next.js) — S03.
 *
 * ⚠ MỘT hằng nuôi HAI khoá bên dưới, cố ý:
 *   · `domain.urlCongSvMoi`        — guard chuyển hướng `/workspace` và `/login`
 *   · `authen.useCustomLoginPageURL` — `AccessTokenGuard` và interceptor v1 dùng
 *     thẳng `window.location.href`, KHÔNG qua router nên guard không bắt được
 *
 * Khai rời hai chỗ là sớm muộn cũng lệch nhau, mà lệch thì một nửa lối đi về
 * cổng mới còn một nửa ở lại app cũ — không có gì báo.
 *
 * ⚠ KHÔNG dùng `domain.urlWebLogIn` cho việc này: khoá đó kiêm `backlink` của SSO
 * (`authen.config.ts` §sso), đổi là gãy đăng nhập SSO của chính app này.
 */
const CONG_SV_MOI = 'https://sinhvien.ttithutech.com';

export const environment = {
  production: false,
  /**
   * ⛔ GHI ĐÈ danh sách mã quyền sau đăng nhập — CHỈ local và test.
   * Xem `environment.dev.ts`. `environment.prod.ts` / `.beta.ts` để mảng rỗng.
   */
  authMenuOverride: [
    '9865', '1208', '1218', '1209', '1219', '1220', '1210', '1221', '1222', '1211', '1233',
    '1212', '1217', '1207', '1213', '1214', '1227', '1228', '1229', '1230', '1231', '1223',
    '1224', '1225', '1226', '5288', '5289', '5290', '5292', '5293', '5291', '5294', '5295',
    '5296', '5297', '5298', '5299', '5300', '5301', '5313', '1299', '1300', '1301', '1302',
    '1303', '1304', '1305', '5314', '1319', '5041', '5356', '5357', '5358', '5359', '5360',
    '5131', '5144',
  ] as string[],
  authen: {
    appKey: 'SINHVIEN_DAIHOC',
    apiAuth: 'http://api.lamgigio.net/core-phan-quyen/api-authentication-v2/api/auth',
    // ⚠ S03: trang đăng nhập nay ở cổng mới — xem CONG_SV_MOI phía trên.
    useCustomLoginPageURL: `${CONG_SV_MOI}/login`,
    googleAuthClientID: '',
    facebookAuthSecretKey: '',
    reCapchaSecretKey: '6LcRH0EUAAAAADIgNOVAUuaYVRNi6HfExT3sdr2F',
    useMockData: false,
    autoLoginByMockUser: false,
    supportLink: {
      forgotPassword:
        'https://docs.google.com/document/d/1py_zndTVOcK5Ij1yfVtIaquvZa_aiAU9/pub',
      createNewAccount: '',
      verifyAtLogin:
        'https://docs.google.com/document/d/1py_zndTVOcK5Ij1yfVtIaquvZa_aiAU9/pub',
      canNotLogin:
        'https://docs.google.com/document/d/1py_zndTVOcK5Ij1yfVtIaquvZa_aiAU9/pub',
    },
  },
  domain: {
    apiAuth: 'https://permission.api.ttithutech.com/v2/api',
    apiNoiQuyLaoDong: 'http://nqld.api.ttithutech.com/api',
    apiNoiQuyLaoDongVersion2: 'http://nqldv10.api.ttithutech.com/api',
    apiKhenThuongKyLuat: 'https://api.hutech.edu.vn/api-ktkl-v2/api',
    serverSendEventDomain: 'https://api.hutech.edu.vn/api-ticket-management/api/sse',
    apiTicketManagement: 'http://hoi-dap.api.ttithutech.com/api',
    urlSSOHUTECH: 'https://sso.hutech.edu.vn',
    urlWebLogIn: 'https://erp1.hutech.edu.vn/#/admin/login/login',
    urlWebOld: 'https://erp1.hutech.edu.vn/#',
    /**
     * Cổng sinh viên MỚI (Next.js) — lối "Trở về Workspace".
     *
     * ⚠ S03: Workspace nay chạy ở cổng RIÊNG, không còn là `/workspace` nội bộ
     *   của app này. Giá trị KHÁC NHAU ở cả 4 môi trường — khai thiếu một tệp
     *   là môi trường đó trỏ nhầm sang production.
     */
    urlCongSvMoi: CONG_SV_MOI,
    urlEduzaa: "https://eduzaa.hutech.edu.vn",
    urlRootPortal: 'http://erp2.hutech.edu.vn/Secure/PageLogin.aspx',
    urlRootErp: 'http://erp.hutech.edu.vn/Account/Login',
    urlRootErpTest: 'http://report.hutech.edu.vn',
    apiDaoTaoBoiDuongVPT: 'http://vpt-dtbd.api.ttithutech.com/api',
    apiDonPhieuOnlineVHTPTDT: 'https://api.hutech.edu.vn/api-htptdt-don-phieu/api',
    apiCauHinhChung: 'https://api.hutech.edu.vn/cau-hinh-chung',
    apiTuyenSinhCapDongPhuc: 'http://ts-cdp.api.ttithutech.com/api',
    apiChuaPhanLoai: 'https://api.hutech.edu.vn/api-chua-phan-loai/api',
    /**
    * (admin-sys-notify) Doamin api phuc vu module
    */
    apiNotify: 'https://apidemo.lamgigio.net/notifi/localhost/api',
    apiDangKyTHNNKN: 'https://ttth-nn-kn.api.ttithutech.com/api',

    /**
     * (thu-thap-thong-tin-truc-tuyen) Domain api chinh thong tin truc tuyen
     */
    apiThuThapThongTinTrucTuyen: 'https://api.hutech.edu.vn/api-tuyen-sinh-thu-thap-thong-tin/api',

    /**
     * (tuyen-sinh-dang-ky-hoc-bong)
     */
    apiTuyenSinhDangKyHocBong: 'http://xet-hoc-bong.api.ttithutech.com/api',

    /**
     * BA dịch vụ E-learning cùng tồn tại — KHÔNG phải 3 phiên bản nối tiếp nhau
     * của một dịch vụ, mà là 3 nhóm đầu mối khác nhau. Đặt tên theo đúng hậu tố
     * đường dẫn thật để khỏi phải tra lại mỗi lần thêm đầu mối:
     *
     *   apiElearningV1 — `api-elearning`     : lop-hoc-phan · newsletters · tkb ·
     *                                          nam-hoc-hoc-ky  (nhóm Học vụ)
     *   apiElearningV2 — `api-elearning-v2`  : tkb-sinh-vien · diem-sinh-vien ·
     *                                          lich-thi-sinh-vien · nam-hoc-hoc-ky
     *   apiElearningV3 — `api-elearning-v3`  : sinh-vien-dashboard (panel Workspace)
     *
     * ⚠ V3 KHÔNG bao trùm V1: đổi `apiElearningV1` sang `api-elearning-v3` là
     * mất toàn bộ nhóm Học vụ. `web_erp_v4` và `web_portal_sinh_vien_v3` đều
     * đang gọi cùng bộ đầu mối đó trên `api-elearning`.
     */
    apiElearningV1: 'http://elearning.api.ttithutech.com/api',
    /**
     * ⚠ Môi trường `testing` CHƯA CÓ dịch vụ `api-elearning-v2` — bản v3 cũng
     * để trống đúng chỗ này. 4 màn Xem điểm / Lịch thi / TKB / Năm học sẽ gọi
     * vào chuỗi rỗng ở môi trường này cho tới khi nhóm dịch vụ cấp địa chỉ.
     */
    apiElearningV2: '',
    apiElearningV3: '',
    // excel
    importExcel: '',

    /**
   * Api support account team
   */
    apiSupportAccountTeam: '',
    apiHoSoCaNhanV2: 'https://hssv-v2.api.ttithutech.com/api',
  },
  path: {
    /**
     * ⚠ Khoá này TRƯỚC ĐÂY THIẾU ở riêng `environment.test.ts`, làm
     * `ng build --configuration=testing` gãy ở
     * `features/auth/.../finished-form.component.ts` (TS2339) — lỗi có từ trước
     * đợt chuyển S01, không liên quan tới 3 nhóm chức năng mới.
     * Giữ đúng giá trị của beta/prod: đây là địa chỉ công khai, không theo môi trường.
     */
    external_link: {
      webDaoTao: 'https://daotao.hutech.edu.vn',
    },
    dashboard: {
      capTruongChartPath: 'https://docs.google.com/spreadsheets/d/13M3LZ8e4OaV8v3PjALLpinxM9psNtYRgvqzT4GbH_JU/edit#gid=1725652438',
      capKhoaChartPath: 'https://docs.google.com/spreadsheets/d/13M3LZ8e4OaV8v3PjALLpinxM9psNtYRgvqzT4GbH_JU/edit#gid=1725652438',
    },
    quan_ly_cap_truong: {
      quan_ly_ky_luat: {
        importQuyetDinhKyLuatPath: '/admin/import-excel/request-import/create/ctsv-ktkl?key=78',
        importCapNhatKyLuatPath: '/admin/import-excel/request-import/create/ctsv-ktkl?key=77',
        importKyLuatPath: '/admin/import-excel/request-import/create/ctsv-ktkl?key=76',
      },
      quan_ly_khen_thuong: {
        importCapNhatKhenThuongPath: '/admin/import-excel/request-import/create/ctsv-ktkl?key=75',
        importKhenThuongPath: '/admin/import-excel/request-import/create/ctsv-ktkl?key=74',
      }
    },
    huong_dan: {
      huongDanPath: 'https://wiki.ttithutech.com/books/quan-ly-khen-thuong-ky-luat-cua-sinh-vien/page/gioi-thieu-chung',
    },
    /**
     * Link google sheet notify cua module admin quan ly thong bao (admin-sys-notify)
     */
    notify: {
      sheetScheduleURL: 'https://docs.google.com/spreadsheets/d/1u65n9dV8x6_4-LECu-5NOvwnC0pAuplXDn_YIzaKsKw'
    }
  },
  developer: {
    username: "NNV0050588",
    password: "123qwe@..",
  },
  storage: {
    cookies: {
      expireInSeconds: 3600 // 1 hour
    }
  },
  application: {
    http: {
      // http request timeout
      timeout: 30 * 1000 // 30 giây
    },
    responseBodyVersion: '1.0.0', // Phiên bản của định dạng dữ liệu trả về từ API
    /**
     * @deprecated by authen group
     * need change metadata.app to authen.appKey
     */
    metadata: {
      capcha: null, //TODO-HTUECH: key này để làm gì? quy tắt setting ntn
      app: 'HUTECH', //TODO-HTUECH: app key?
      diuu: '123',
      key_option_xac_thuc: 'erp1', //TODO-HTUECH: key này để làm gì? quy tắt setting ntn
    },

    /**
     * @deprecated by config/ui.const.ts variable
     * Do not use this valiable for newer module GLOBAL_CONFIG_PAGE_SIZE
     */
    ui: {
      pagingation: {
        pageSizeDefault: 10, // Số mục trên mỗi trang
        pageSizeOptions: [10, 20, 50, 100, 200], // Tùy chọn kích thước trang,
      },
    },
    storage: {
      cookies: {
        expireInSeconds: 3600, // 1 hour
      },
    },
    /**
     * Phần hướng dẫn (product tour — sys-tour / shepherd).
     *
     * `enabled: false` tắt HẲN: không dựng nút "Hướng dẫn", không tự chạy.
     * `autoRun: false` chỉ tắt lần tự chạy đầu tiên — nút vẫn còn để xem chủ động.
     *
     * Nhớ: mỗi trình duyệt vẫn tự nhớ "đã xem" qua localStorage, nên bật lại cờ
     * này KHÔNG làm tour hiện lại với người đã xem.
     */
    tour: {
      enabled: true,
      autoRun: true,
    },
    package_version: version,
    baseHref: '/',
  }
};
